import cn from 'classnames';
import { MdFolder, MdGridView, MdLocalFireDepartment, MdTrendingDown } from 'react-icons/md';
import { InteractiveSpan } from '@Components/InteractiveEl';
import { CreativeThumb, MetricGrid, RecBox, SectionCard, SrcCue, Tag } from './CreativeSuiteShared';
import {
  CsGreen,
  CsOrange,
  CsRed,
  FATIGUE_ADS,
  FATIGUE_METRICS,
  FATIGUE_RECS,
  FATIGUE_SET,
  FATIGUE_THRESHOLD,
  FatigueAd
} from './creativeSuite-constants';

const barColor = (fatigue: number) => {
  if (fatigue >= FATIGUE_THRESHOLD) return CsRed;
  if (fatigue >= 0.6) return CsOrange;
  return CsGreen;
};

const FlaggedSetHeader = () => (
  <div className='flagged-set'>
    <MdLocalFireDepartment aria-hidden className='flame' />
    <div className='flagged-body'>
      <div className='flagged-title'>
        <span className='nm'>{FATIGUE_SET.adset}</span>
        <span className='set-link'>
          <MdFolder aria-hidden /> Campaign: {FATIGUE_SET.campaign}
        </span>
      </div>
      <div className='flagged-stats'>
        Fatigue {FATIGUE_SET.fatigue} (&gt;0.80) · freq {FATIGUE_SET.frequency} · spend{' '}
        {FATIGUE_SET.spend} · CPA {FATIGUE_SET.cpa}{' '}
        <span className='muted'>({FATIGUE_SET.cpaInflation})</span>
      </div>
    </div>
    <Tag variant='red' icon={<MdTrendingDown aria-hidden />}>
      Act now
    </Tag>
  </div>
);

const FatigueAdRow = ({ ad, first }: { ad: FatigueAd; first: boolean }) => (
  <div className={cn('bp-row', { 'row-first': first })}>
    <CreativeThumb kind={ad.kind} />
    <div className='ad-meta'>
      <div className='ad-name'>
        {ad.name} — {ad.format}
      </div>
      <div className='ad-sub'>
        <span className='set-link'>
          <MdGridView aria-hidden /> {ad.adset}
        </span>{' '}
        · live {ad.liveDays}d
      </div>
    </div>
    <div className='ad-fatigue'>
      <div className='ad-fatigue-lab'>
        Fatigue {ad.fatigue.toFixed(2)} · freq {ad.frequency}
      </div>
      <div className='fatigue-bar'>
        <span style={{ width: `${ad.fatigue * 100}%`, background: barColor(ad.fatigue) }} />
      </div>
    </div>
    <div className='ad-perf'>
      CTR <span className={cn('tone', ad.ctrTone)}>{ad.ctr}</span> · CPA {ad.cpa}
    </div>
    <InteractiveSpan className='mini-btn'>Creative</InteractiveSpan>
  </div>
);

export const FatigueView = () => (
  <div className='bp-panel'>
    <MetricGrid metrics={FATIGUE_METRICS} columns={4} />

    <SectionCard
      title='High fatigue · drill into ads'
      sub='Ad set → most fatigued ads → paired creatives'
      right={<SrcCue />}
    >
      <FlaggedSetHeader />
      {FATIGUE_ADS.map((ad, i) => (
        <FatigueAdRow key={ad.name} ad={ad} first={i === 0} />
      ))}
      {FATIGUE_RECS.map(rec => (
        <RecBox key={rec.title} rec={rec} />
      ))}
    </SectionCard>
  </div>
);
